import { anodum } from '@yola/ws-sdk';

const parseTemplateFromString = (html) => {
  const template = document.createElement('template');
  template.innerHTML = anodum.normalizeHTML(html);
  return template;
};

export default parseTemplateFromString;
